import angular from 'angular';
import pipelineLabelSelector from './pipelineLabelSelector';
import './style.scss';

export default angular
  .module('components.pipelineLabelSelector', [])
  .component('pipelineLabelSelector', pipelineLabelSelector).name;
